module.exports = __webpack_public_path__ + "static/media/epa-background.685bc7c2.svg";